'use strict'
module.exports = Function.prototype.bind
